/* Health Walkthrough Popover Styles */
/* Using doubled selectors for higher specificity to override driver.js defaults */

export const healthWalkthroughStyles = {
    '.health-walkthrough-popover.health-walkthrough-popover': {
        backgroundColor: 'green.default',
        border: 'none',
        borderRadius: 0,
        boxShadow: 'none',
        maxWidth: '289px',
        padding: '9px 9px 12px 9px',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-title': {
        fontFamily: 'body',
        fontSize: '12px',
        fontWeight: 400,
        color: 'beige.default',
        lineHeight: 1.6,
        marginBottom: '3px',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-description': {
        fontFamily: 'body',
        fontSize: '11px',
        fontWeight: 400,
        color: 'captions.dark',
        lineHeight: '17px',
        marginBottom: '8px',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-footer': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '8px',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-navigation-btns': {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        flex: 1,
        justifyContent: 'space-between',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-prev-btn': {
        fontFamily: 'body',
        fontSize: '10px',
        fontWeight: 500,
        color: 'beige.default',
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: 'stroke.dark',
        borderRadius: '6px',
        padding: '6px 9px',
        textShadow: 'none',
        textTransform: 'uppercase',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-prev-btn:hover': {
        backgroundColor: 'beige.transparent_10',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-next-btn, .health-walkthrough-popover.health-walkthrough-popover .driver-popover-done-btn':
        {
            fontFamily: 'body',
            fontSize: '10px',
            fontWeight: 500,
            color: 'green.default',
            backgroundColor: 'neon.100',
            border: 'none',
            borderRadius: '6px',
            padding: '6px 9px',
            textShadow: 'none',
            textTransform: 'uppercase',
        },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-next-btn:hover, .health-walkthrough-popover.health-walkthrough-popover .driver-popover-done-btn:hover':
        {
            backgroundColor: 'neon.80',
        },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-close-btn': {
        display: 'none',
    },

    /* Popover progress text */
    '.health-walkthrough-popover.health-walkthrough-popover .health-walkthrough-progress': {
        fontFamily: 'body',
        fontSize: '9px',
        fontWeight: 500,
        color: 'beige.default',
        textTransform: 'uppercase',
        marginLeft: 'auto',
    },

    /* Arrow styling - matches popover background */
    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-arrow-side-left': {
        borderLeftColor: 'green.default',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-arrow-side-right': {
        borderRightColor: 'green.default',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-arrow-side-top': {
        borderTopColor: 'green.default',
    },

    '.health-walkthrough-popover.health-walkthrough-popover .driver-popover-arrow-side-bottom': {
        borderBottomColor: 'green.default',
    },

    /* Show circular progress when element is highlighted */
    '.driver-active-element.driver-active-element .health-walkthrough-progress-indicator': {
        display: 'block',
    },
}
